import { StyleSheet } from 'react-native';

// 基础样式（不依赖主题颜色）
export const baseStyles = StyleSheet.create({
    container: {
        borderRadius: 8, // medium
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'row',
        minHeight: 40,
    },
    small: {
        paddingHorizontal: 8, // sm
        paddingVertical: 4,   // xs
        minHeight: 32,
    },
    medium: {
        paddingHorizontal: 16, // md
        paddingVertical: 8,    // sm
        minHeight: 40,
    },
    large: {
        paddingHorizontal: 24, // lg
        paddingVertical: 16,   // md
        minHeight: 48,
    },
    disabled: {
        opacity: 0.6,
    },
    text: {
        fontWeight: '600',
        fontSize: 16,
    },
    // 图标样式
    iconContainer: {
        justifyContent: 'center',
        alignItems: 'center',
    },
    iconLeft: {
        marginRight: 6,
    },
    iconRight: {
        marginLeft: 6,
    },
    // 内容容器
    contentContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
    },
    // 尺寸对应的文字大小
    smallText: {
        fontSize: 14,
    },
    mediumText: {
        fontSize: 16,
    },
    largeText: {
        fontSize: 18,
    },
});

// 动态样式生成函数（需要传入主题颜色）
export const getDynamicStyles = (primaryColor: string) =>
    StyleSheet.create({
        primary: {
            backgroundColor: primaryColor,
        },
        secondary: {
            backgroundColor: '#8E8E93', // secondary color
        },
        outline: {
            backgroundColor: 'transparent',
            borderWidth: 1,
            borderColor: primaryColor,
        },
        ghost: {
            backgroundColor: 'transparent',
        },
        primaryText: {
            color: '#FFFFFF',
        },
        secondaryText: {
            color: '#FFFFFF',
        },
        outlineText: {
            color: primaryColor,
        },
        ghostText: {
            color: primaryColor,
        },
    });

// 图标尺寸配置
export const getIconSize = (size: string): number => {
    switch (size) {
        case 'small':
            return 16;
        case 'large':
            return 24;
        default:
            return 20;
    }
};

// 图标颜色配置
export const getIconColor = (variant: string, primaryColor: string): string => {
    switch (variant) {
        case 'primary':
            return '#FFFFFF';
        case 'secondary':
            return '#FFFFFF';
        case 'outline':
        case 'ghost':
            return primaryColor;
        default:
            return '#FFFFFF';
    }
};
